import classes from "./style/NextArrow.module.css";

function NextArrow(props) {
  const { className, onClick } = props;
  const style = { right: -15, zIndex: 100 };
  return (
    <div
      className={
        className +
        " rounded bi bi-arrow-right-square-fill " +
        classes["next-button"]
      }
      style={style}
      onClick={onClick}
    />
  );
}

export { NextArrow };
